import { CategorizationMap } from "portal/utils/categoryCollection/category";
import {
  PredictionPoint,
  SessionStatus,
} from "protos/veselka/prediction_point";
import { PredictionPointExpandedImage } from "../expandedImage/PredictionPointExpandedImage";
import { RadioChipOption } from "portal/components/RadioChips";
import React, { FC } from "react";

interface ExpandedImageState {
  index: number;
  data: PredictionPoint;
  editableCategoryId?: string;
}

interface CategorizedImageExpandedViewProps {
  expandedImage: ExpandedImageState | undefined;
  setExpandedImage: React.Dispatch<
    React.SetStateAction<ExpandedImageState | undefined>
  >;
  onNext?: (() => void) | undefined;
  onBack?: (() => void) | undefined;
  categoryOptions: RadioChipOption[];
  categorizationMap: CategorizationMap;
  onClassify?: (predictionPointId: string, categoryId: string) => void;
  session?: {
    processing: boolean;
    stale: boolean;
    status?: SessionStatus;
  };
}

export const CategorizedImageExpandedView: FC<
  CategorizedImageExpandedViewProps
> = ({
  expandedImage,
  setExpandedImage,
  onNext,
  onBack,
  categoryOptions,
  categorizationMap,
  onClassify,
  session,
}) => {
  return (
    <PredictionPointExpandedImage
      open={Boolean(expandedImage)}
      onClose={() => {
        setExpandedImage(undefined);
      }}
      onNext={onNext}
      onBack={onBack}
      predictionPoint={expandedImage?.data}
      categoryOptions={categoryOptions}
      categoryId={expandedImage?.editableCategoryId}
      onClassify={
        onClassify
          ? (predictionPointId, categoryId) => {
              onClassify(predictionPointId, categoryId);
              setExpandedImage((prev) => {
                if (!prev) {
                  return;
                }
                const isUnclassifying = prev.editableCategoryId === categoryId;
                return {
                  ...prev,
                  editableCategoryId: isUnclassifying ? undefined : categoryId,
                };
              });
            }
          : undefined
      }
      isSessionStale={session?.stale}
      categorizationMap={categorizationMap}
    />
  );
};
